'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function useKeyPress(keys, callback) {
    const [pressedKeys, setPressedKeys] = React.useState(new Set());
    const [callbackInvoked, setCallbackInvoked] = React.useState(false);
    React.useEffect(()=>{
        function handleKeyDown(event) {
            setPressedKeys((prevKeys)=>new Set([
                    ...prevKeys,
                    event.key
                ]));
        }
        function handleKeyUp(event) {
            const newKeys = new Set(pressedKeys);
            newKeys.delete(event.key);
            setPressedKeys(newKeys);
            setCallbackInvoked(false);
        }
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [
        pressedKeys
    ]);
    React.useEffect(()=>{
        const hasAllKeysPressed = keys.every((key)=>pressedKeys.has(key));
        if (!callbackInvoked && hasAllKeysPressed) {
            setCallbackInvoked(true);
            callback();
        }
    }, [
        pressedKeys,
        keys,
        callback,
        callbackInvoked
    ]);
}

exports.useKeyPress = useKeyPress;
//# sourceMappingURL=use-key-press.js.map
